import { Position } from "geojson";
//Convierte una coordenada decimal a GMS
const coordConverter = (coord: number): string => {
  const coordAbs = Math.abs(coord); //Valor absoluto
  const coordGr = Math.floor(coordAbs * 1); //Coordenadas en grados
  const coordMin = Math.floor((coordAbs - coordGr) * 60); //Se calculan los minutos
  const coordSec = (((coordAbs - coordGr) * 60 - coordMin) * 60).toFixed(2); //Segundos
  const coordGMS = `${coordGr}° ${coordMin}' ${coordSec}"`;
  return coordGMS;
};

const coordsFormater = (coordArray: Position): string[] => {
  if (coordArray.length) {
    const lat = coordArray[1];
    const lng = coordArray[0];
    let latGMS = coordConverter(lat);
    let lngGMS = coordConverter(lng);
    lat > 0 ? (latGMS += " N ") : (latGMS += " S ");
    lng > 0 ? (lngGMS += " E") : (lngGMS += " W");
    return [latGMS, lngGMS];
  } else {
    return ["", ""];
  }
};

export default coordsFormater;
